import React, { useState }  from "react";
import InputField from "components/fields/InputField";
import Button from "components/button";
import CardItem from "components/card/CardItem";
import AvatarLogo from 'assets/img/logo/avatar.png';
import { connect } from "react-redux";
import { loginRequest } from "../../redux/auth/authState";
import { Alert } from 'antd';
import ApplicationName from "components/app-name";

const SignIn = ({ login, loading, error }) => {
  const [inputs, setInputs] = useState({});
  
  const handleChange = (event) => {
    const name = event.target.id;
    const value = event.target.value;
    setInputs(values => ({...values, [name]: value}));
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    try {   
      login({username: inputs.username, password:inputs.password});
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  return (
    <div className="mb-16 flex flex-row flex-wrap gap-10 h-full w-full items-center justify-center px-4 md:mx-0 md:px-0 lg:mt-[100px] lg:mb-10 lg:items-center lg:justify-start">
      
      <div className="frosted-glass dark:!bg-purple-100/90 flex items-center justify-center rounded-[30px] w-[320px] text-center lg:w-[420px] min-h-0 xl:min-h-[400px]">
        <ApplicationName extra="w-[300px]" logoClass="logo-lg" companyNameClass="company-name-center mt-4"/>
      </div>

      {/* Sign in section */}
      <CardItem 
      extra="glass-card w-[400px] border dark:border-gray-600"
      icon={<img src={AvatarLogo} alt="Company Name" className="rounded-full"/>}
      title="Sign In"
      titleClass="text-3xl dark:text-white">
      
      <form className="form rounded-[30px]" onSubmit={handleSubmit}>
        <div className="h-full w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
        
          <InputField
            variant="auth"
            extra="mb-3"
            label="Username*"
            placeholder="yourname@hyvidone.com"
            id="username"
            type="text"
            value={inputs.username}
            onChange={handleChange}
          />

          <InputField
            variant="auth"
            extra="mb-3"
            label="Password*"
            placeholder="Min. 8 characters"
            id="password"
            type="password"
            value={inputs.password}
            onChange={handleChange}
          />

          <div className="mb-5 flex items-center justify-end px-2">            
            <a
              className="text-sm font-medium text-theme-500 hover:text-theme-600 dark:text-white"
              href=" "
            >
              Forgot Password?
            </a>
          </div>    
          <Button type="submit" extra={`btn btn-primary text-white font-bold w-full ${loading && 'disabled'}`} disabled={loading}>
            Submit
          </Button>
          <div className="min-h-[16px] mt-3">
            {error && <Alert className="mb-2" message={error} type="error" showIcon />} 
          </div>
        </div>
      </form>
      </CardItem>
    </div>
  );
}

const mapStateToProps = (state) => ({
  loading: state.auth.loading,
  error: state.auth.error,
});

const mapDispatchToProps = (dispatch) => ({
  login: (username, password) => dispatch(loginRequest(username, password)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);
